<template>
  <v-app>
    <template v-if="servidorPronto">
      <v-app-bar app color="secondary" dark dense>
        <v-toolbar-title class="d-flex align-center">
          <button
            type="button"
            class="d-flex"
            aria-label="Ir para a tela inicial"
            @click="checkForChangesBeforeNavigation('/listaConfiguracoes')"
          >
            <img :src="logoUrl" alt="Encaixe" width="32" height="32" />
          </button>
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip v-if="$route.name === 'Passos'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              aria-label="Recarregar"
              v-bind="attrs"
              v-on="on"
              @click="recarregarTela"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Recarregar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              aria-label="Alternar tema claro/escuro"
              v-bind="attrs"
              v-on="on"
              @click="toggleDarkMode"
            >
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
          </template>
          <span>Alternar tema claro/escuro</span>
        </v-tooltip>
        <v-btn
          v-for="link in links"
          :key="link.text"
          text
          rounded
          @click="checkForChangesBeforeNavigation(link.route)"
          >{{ link.text }}</v-btn
        >
        <v-tooltip v-if="this.$store.state.authToken" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              aria-label="Sair"
              v-bind="attrs"
              v-on="on"
              @click="checkForChangesBeforeLogout"
            >
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </v-app-bar>

      <v-main>
        <router-view
          ref="current-component"
          @confirm-navigation="confirm(prentedRoute)"
        />
      </v-main>

      <v-dialog v-model="dialogSair" max-width="400">
        <v-card>
          <v-card-title class="text-h6">Deseja sair?</v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="dialogSair = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="confirmarSaida">Sair</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConflito" max-width="520">
        <v-card>
          <v-card-title class="text-h6">Configuração alterada</v-card-title>
          <v-card-text>{{
            $store.state.conflitoRevisao && $store.state.conflitoRevisao.message
          }}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="recarregarAposConflito"
              >Recarregar</v-btn
            >
            <v-btn color="primary" text @click="dialogConflito = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-app>
</template>

<script>
import {
  aguardarServidor,
  aguardarSplashMinimo,
} from "@/util/aguardarServidor";

export default {
  name: "App",

  data: () => ({
    links: [{ text: "Configurações", route: "/listaConfiguracoes" }],
    prentedRoute: null,
    logoutConfirmationMessage:
      "Você tem alterações não salvas, que serão perdidas. Tem certeza que deseja sair?",
    navigationConfimationMessage:
      "Você tem alterações não salvas, que serão perdidas. Tem certeza que deseja sair dessa tela?",
    servidorPronto: false,
    logoUrl: process.env.BASE_URL + "encaixe-barra.svg",
    dialogSair: false,
  }),

  mounted() {
    this.checkLocalStorage();
    document
      .getElementById("splash-tentar")
      .addEventListener("click", this.conectarServidor);
    this.conectarServidor();
  },

  computed: {
    dialogConflito: {
      get() {
        return !!this.$store.state.conflitoRevisao;
      },
      set(valor) {
        if (!valor) this.$store.commit("setConflitoRevisao", null);
      },
    },
  },
  methods: {
    async conectarServidor() {
      document.getElementById("splash").classList.remove("falhou");
      const [pronto] = await Promise.all([
        aguardarServidor(process.env.VUE_APP_BASE_URL),
        aguardarSplashMinimo(),
      ]);
      this.servidorPronto = pronto;
      const splash = document.getElementById("splash");
      splash.classList.toggle("falhou", !pronto);
      splash.classList.toggle("oculto", pronto);
    },
    checkForChangesBeforeLogout() {
      const stepsComponentOpen =
        this.$route.name === "Passos" && this.$refs["current-component"];
      const hasUnsavedChanges =
        stepsComponentOpen && !this.$refs["current-component"].handlePageExit();

      if (hasUnsavedChanges) {
        this.$store.dispatch(
          "setConfirmationDialogMessage",
          this.logoutConfirmationMessage
        );
        this.prentedRoute = "logout";
      } else {
        this.prentedRoute = null;
        this.dialogSair = true;
      }
    },
    checkForChangesBeforeNavigation(route) {
      const stepsComponentOpen =
        this.$route.name === "Passos" && this.$refs["current-component"];
      const hasUnsavedChanges =
        stepsComponentOpen && !this.$refs["current-component"].handlePageExit();

      if (hasUnsavedChanges) {
        this.$store.dispatch(
          "setConfirmationDialogMessage",
          this.navigationConfimationMessage
        );
        this.prentedRoute = route;
      } else {
        this.prentedRoute = null;
        this.navigate(route);
      }
    },
    confirm(payload) {
      const stepsComponentOpen =
        this.$route.name === "Passos" && this.$refs["current-component"];
      if (stepsComponentOpen) {
        this.$refs["current-component"].beforeChangeStep();
      }

      this.prentedRoute = null;
      if (payload === "logout") {
        return this.logout();
      }
      this.navigate(payload);
    },
    navigate(route) {
      this.$router.push(route).catch(() => {});
      this.prentedRoute = null;
    },
    checkLocalStorage() {
      const token = localStorage.getItem("authToken");
      if (token != null && token.length > 0) {
        this.$store.dispatch("setAuthToken", token);
        this.$router.push({ name: "ListaConfiguracoes" }).catch(() => {});
      }
      const darkMode = Number(localStorage.getItem("dark"));
      if (darkMode != null) {
        this.$vuetify.theme.dark = Boolean(darkMode);
      } else {
        this.$vuetify.theme.dark = false;
      }
    },
    logout() {
      this.$store.dispatch("clearAuthToken");
      this.$router.push({ name: "Autenticacao" });
    },
    confirmarSaida() {
      this.dialogSair = false;
      this.logout();
    },
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark", Number(this.$vuetify.theme.dark));
    },
    recarregarAposConflito() {
      this.dialogConflito = false;
      const tela = this.$refs["current-component"];
      if (tela && tela.descartarERecarregar) {
        tela.descartarERecarregar();
      }
    },
    recarregarTela() {
      const tela = this.$refs["current-component"];
      if (tela && tela.handleRefreshClick) {
        tela.handleRefreshClick();
      }
    },
  },
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

.v-application.theme--light,
.v-application.theme--dark {
  background-color: var(--v-fundo-base) !important;
}
</style>
